import styled, { css } from 'styled-components';
import { rem } from '../../utils';
export const SliderContainer = styled.div `
  width: 100%;
`;
export const StyledSliderThumb = css `
  -webkit-appearance: none;
  appearance: none;
  width: ${({ theme }) => rem(theme.Form.Slider.thumb.size)};
  height: ${({ theme }) => rem(theme.Form.Slider.thumb.size)};
  border-radius: 50%;
  background: ${({ theme }) => theme.Color.Neutrals.Paper};

  border: ${({ theme }) => `${rem(theme.Form.Slider.thumb.border.width)} solid ${theme.Form.Slider.thumb.border.color}`};
  cursor: pointer;
  transition: all ${({ theme }) => theme.Transition.Timing.Out};

  &:hover {
    border-color: ${({ theme }) => theme.Color.Brand.Primary};
    box-shadow: ${({ theme }) => theme.Form.Slider.thumb.shadow};
  }

  &:active {
    box-shadow: none !important;
  }
`;
export const StyledSliderTrack = css `
  width: 100%;
  height: ${({ theme }) => rem(theme.Form.Slider.track.height)};

  cursor: pointer;
  background: ${({ value, min, max, theme }) => `
  linear-gradient(
    to right,
    ${theme.Color.Brand.Primary} 0%,
    ${theme.Color.Brand.Primary} ${((value - min) / (max - min)) * 100}%,
    ${theme.Color.Neutrals.Border} ${((value - min) / (max - min)) * 100}%,
    ${theme.Color.Neutrals.Border} 100%
  )
`};

  border-radius: ${({ theme }) => rem(theme.Border.Radius.Small)};
  border: none;
`;
export const SliderInput = styled.input `
  -webkit-appearance: none;
  width: 100%;
  height: ${({ theme }) => rem(theme.Form.Slider.thumb.size)};
  background: transparent;
  border-radius: ${({ theme }) => rem(theme.Border.Radius.Small)};
  outline: none;
  padding: 0;
  margin: 0;

  &::-webkit-slider-thumb {
    ${StyledSliderThumb}
    transform: translateY(calc(-50% + 1px));
  }

  &::-moz-range-thumb {
    ${StyledSliderThumb}
  }

  &::-webkit-slider-runnable-track {
    ${StyledSliderTrack}
  }

  &::-moz-range-track {
    ${StyledSliderTrack}
  }
`;
//# sourceMappingURL=Slider.style.js.map